import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tree-archivos',
  template: `
    <ul class="tree-archivo">
        <li *ngFor="let item of estructura" [hidden]="item.tipo_archivo == 1 || !visualizarCarpeta(item)">
            <div class="carpeta">
              <div [style.padding-left]="30*nivel+'px'">
                <i class="fas fa-plus" *ngIf="contarCarpetasArchivo(item,0) > 0" (click)="item.mostrar = !item.mostrar" [hidden]="item.mostrar"></i>
                <i class="fas fa-minus" *ngIf="contarCarpetasArchivo(item,0) > 0" (click)="item.mostrar = !item.mostrar" [hidden]="!item.mostrar"></i>
                <i class="icono far" [ngClass]="{'fa-folder': !item.activo,'fa-folder-open': item.activo}"></i>
                <span class="nombre card-puntero" (click)="emittClicCarpeta.emit(item)">{{item.descripcion}} ({{contarCarpetasArchivo(item, 1)}})</span>
              </div>
              <div class="carpeta-botones">
                <i class="p-1 ml-1 mr-1 text-primary  f-14 fas fa-plus" 
                (click)="emittCrearCarpetas.emit(item)" 
                title="Crear Carpeta"
                *ngIf="validarCreadorAdmin(item)"></i>
                <i class="p-1 ml-1 mr-1 text-success  f-14 fas fa-paperclip" 
                  (click)="emittSubirArchivo.emit(item)" 
                  title="Subir Archivo"
                  *ngIf="validarRolesCrearModificarArchivo(item)"></i>
                <i class="p-1 ml-1 mr-1 text-warning   f-14  fas fa-pencil-alt" 
                    (click)="emittModificarCarpeta.emit(item)" 
                    title="Modificar Carpeta"
                    *ngIf="validarCreadorAdmin(item)"></i>
                <i class="p-1 ml-1 mr-1 text-danger  f-14 fas fa-trash-alt" 
                  (click)="emittEliminarCarpeta.emit(item)" 
                  title="Eliminar Carpeta"
                  *ngIf="validarCreadorAdmin(item)"></i>
                <i class="p-1 ml-1 mr-1 text-info   f-14 fas fa-users" 
                  (click)="emittRol.emit(item)" 
                  title="Permisos Administración"
                  *ngIf="validarCreadorAdmin(item)"></i>
              </div>
             
            </div>
            <tree-archivos 
              [estructura]="item.children" 
              [usuario]="usuario"
              [nivel]="nivel+1"
              [permisos]="permisos"
              [hidden]="item.mostrar" *ngIf="item.children.length > 0"
              (emittCrearCarpetas)="emittCrearCarpetas.emit($event)"
              (emittSubirArchivo)="emittSubirArchivo.emit($event)"
              (emittModificarCarpeta)="emittModificarCarpeta.emit($event)"
              (emittEliminarCarpeta)="emittEliminarCarpeta.emit($event)"
              (emittEliminarArchivo)="emittEliminarArchivo.emit($event)"
              (emittModificarArchivo)="emittModificarArchivo.emit($event)"
              (emittDescargarArchivo)="emittDescargarArchivo.emit($event)"
              (emittClicCarpeta)="emittClicCarpeta.emit($event)"
              (emittRol)="emittRol.emit($event)"
              > </tree-archivos>
        </li>
    </ul>
  `,
  styles: []
})
export class TreeArchivosComponent implements OnInit {
  @Input() estructura : any
  @Input() mostrar: any = false
  @Input() permisos: any = []
  @Input() usuario: any  = null
  @Input() nivel: number = 0
  /** Carpetas */
  @Output() emittCrearCarpetas = new EventEmitter()
  @Output() emittSubirArchivo = new EventEmitter()
  @Output() emittEliminarCarpeta= new EventEmitter()
  @Output() emittModificarCarpeta= new EventEmitter()
  @Output() emittClicCarpeta = new EventEmitter()
  /** Archivos */
  @Output() emittDescargarArchivo= new EventEmitter()
  @Output() emittEliminarArchivo= new EventEmitter()
  @Output() emittModificarArchivo= new EventEmitter()
  @Output() emittRol= new EventEmitter()


  constructor() { }

  ngOnInit() {
    //this.emittCrearCarpetas.emit()
  }

  public validarFechasActivacion(item:any){
    if(item.tipo_archivo == 0) return true
    if(item.fecha_cierre_publicacion == null) return true
    let dateNow = new Date().getTime()
    let dateStart = new Date(item.fecha_apertura_publicacion).getTime()
    let dateEnd = new Date(item.fecha_cierre_publicacion).getTime()
    return  (dateNow >= dateStart && dateNow <= dateEnd) ? true : false
  }

  public contarCarpetasArchivo(item:any, id:number){
    if(item == null || item.children.length == 0) return 0
    return item.children.filter((x:any) => x.tipo_archivo == id).length
  }

 

  public visualizarCarpeta(item:any){
    for(let rol of this.usuario.roles){
      if(rol.adm_rol_id == 1) return true
    }
    let permisos = this.permisos.filter((x:any) => x.glb_archivo_compartido_id == item.id)
    if(permisos.length == 0) return false
    for(let rol of this.usuario.roles){
      let buscar = permisos.filter((x:any)=> x.adm_rol_id == rol.adm_rol_id)
       if(buscar.length > 0) return true
   }
   return false
  }

  private validarTipoVisualizacion(item:any, id:number){
    for(let tipo of item.visualiza.split(",")){
      if(tipo == id) return true
    }
    return false
  }

  public validarCreadorAdmin(item: any){
    for(let rol of this.usuario.roles){
      if(rol.adm_rol_id == 1) return true
    }
    if(this.usuario.id == item.creacion_glb_usuario_id) return true

    return false
  }

  public validarRolesCrearModificarArchivo(item:any){
    
    for(let rol of this.usuario.roles){
      if(rol.adm_rol_id == 1) return true
    }
    let permisos = this.permisos.filter((x:any) => x.glb_archivo_compartido_id == item.id)
    if(permisos.length == 0) return false
    for(let rol of this.usuario.roles){
       let buscar = permisos.filter((x:any)=> x.adm_rol_id == rol.adm_rol_id)
        if(buscar.length > 0){
          for(let item of buscar){
            if(item.permiso == 2) return true
          }
        }
    }
    return false
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tree-archivos.component.ts